import BaseController from "sap/mcsuite/controller/BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";

export default class BindingUtils {
	static dynamicBinding(...paths: string[]): unknown {
		const that = this as unknown as BaseController;
		const finalPath = paths.join("/");
		const modelName = finalPath.slice(0, finalPath.indexOf(">"));
		const model = that.getView().getModel(modelName) as JSONModel;
		return model.getProperty(finalPath);
	} 
}
